import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get("/users").then(({ data }) => setUsers(data));
  }, []);

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">IDENTITY</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Users & Roles</h1>
      </div>
      <div className="bin-card overflow-hidden">
        <table className="w-full text-xs font-mono">
          <thead className="bg-[#18181b]">
            <tr className="text-left text-zinc-500">
              <th className="px-4 py-3">Name</th>
              <th>Email</th>
              <th>Roles</th>
              <th>Emergency</th>
              <th>Credits</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-zinc-800">
                <td className="px-4 py-3 font-bold text-white">{u.name}</td>
                <td>{u.email}</td>
                <td>
                  {u.roles.map((r) => (
                    <span key={r} className="inline-block px-1.5 py-0.5 mr-1 border border-zinc-800 rounded text-[0.6rem] uppercase">{r}</span>
                  ))}
                </td>
                <td className={u.emergency_eligible ? "text-emerald-400" : "text-zinc-500"}>
                  {u.emergency_eligible ? "ELIGIBLE" : "—"}
                </td>
                <td className="text-cyan-400">${u.credits_usd?.toFixed(2) || "0.00"}</td>
                <td className="text-zinc-500">{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
